module.exports = __WEBPACK_EXTERNAL_MODULE_23__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 23
// module chunks = 0